var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon64Email(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 7H5.2c-1.1 0-2 .9-2 2v15.7c0 1.1.9 2 2 2H28c1.1 0 2-.9 2-2V9c-.1-1.1-1-2-2.1-2zM4.7 9.8l7.6 7.1L4.7 24V9.8zm13.4 7.6c-.8.8-2.3.8-3.1 0L5.6 8.5h21.9l-9.4 8.9zm-4.7.5l.6.5c.7.7 1.6 1 2.6 1 .9 0 1.9-.3 2.6-1l.6-.5 7.7 7.3H5.7l7.7-7.3zm7.4-1l7.6-7.1V24l-7.6-7.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon64Email);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_64_Email.becded5c.svg";
export { ForwardRef as ReactComponent };